import CoachCard from './coach-card'

export default CoachCard
